export const FETCH_DELETELIST_REQUEST = "FETCH_DELETELIST_REQUEST";
export const FETCH_DELETELIST_SUCCESS = "FETCH_DELETELIST_SUCCESS";
export const FETCH_DELETELIST_FAILURE = "FETCH_DELETELIST_FAILURE";
